<template>
  <div class='flex gap-2'>
    <ContextualRouterLink :to="collection.getInterviewUrl(props.item)" class="text-jananavy-600 hover:text-jananavy-900 font-medium">
      {{ item.status === 'complete' ? 'View' : 'Resume' }} <span class="sr-only">{{ collection.getName(props.item) }}</span>
    </ContextualRouterLink>
  </div>
</template>

<script setup>

import { getCollection } from '@/kernel/collections';

import ContextualRouterLink from '@/components/links/contextual-router-link.vue';

const props = defineProps({
  column: Object,
  item: Object,
  collection: String
});

const collection = getCollection(props.collection);

</script>
